import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';

import useToken from '../../../hooks/useToken';

export const WebAppAccess = () => {
  const { logout } = useToken();
  const history = useHistory();

  return (
    <div className="text-700 text-center mt-7 w-full">
      <h1>Access Denied</h1>
      <h4>
        You don&apos;t have access to this application, please contact your
        admin or support team.
      </h4>
      <div className="text-center">
        <Button
          link
          onClick={() => {
            logout();
            history.push('/dashboard');
          }}
        >
          Logout
        </Button>
      </div>
    </div>
  );
};
